import Nav from "@/views/crm/marketing/whatsapp-broadcast/cloud-api/_nav.vue";
import CloudApiIndex from "@/views/crm/marketing/whatsapp-broadcast/cloud-api/index.vue";
import CloudApiList from "@/views/crm/marketing/whatsapp-broadcast/cloud-api/list.vue";
import CloudApiItem from "@/views/crm/marketing/whatsapp-broadcast/cloud-api/item.vue";
import CloudApiAnalytics from "@/views/crm/marketing/whatsapp-broadcast/cloud-api/analytics.vue";
import Contacts from "@/views/crm/marketing/whatsapp-broadcast/Contacts.vue";

export default [
  {
    path: "whatsapp-broadcasts/api",
    component: CloudApiIndex,
    children: [
      {
        path: "",
        name: "whatsapp-cloud-api-broadcasts",
        component: CloudApiList,
        meta: {
          label: "broadcasts",
          breadcrumbs: ["home", "whatsapp-broadcasts-api"],
        },
      },
      {
        path: ":id",
        component: Nav,
        props: true,
        children: [
          {
            path: "",
            name: "whatsapp-cloud-api-broadcast",
            component: CloudApiItem,
            props: true,
            meta: {
              label: "Broadcast",
              breadcrumbs: [
                "home",
                "whatsapp-cloud-api-broadcasts",
                "whatsapp-cloud-api-broadcast",
              ],
            },
          },
          {
            path: "analytics",
            name: "whatsapp-cloud-api-broadcast-analytics",
            component: CloudApiAnalytics,
            props: true,
            meta: {
              label: "Analytics",
              breadcrumbs: [
                "home",
                "whatsapp-cloud-api-broadcasts",
                "whatsapp-cloud-api-broadcast",
                "whatsapp-cloud-api-broadcast-analytics",
              ],
            },
          },
          {
            path: "contacts",
            name: "whatsapp-cloud-api-broadcast-contacts",
            component: Contacts,
            props: true,
            meta: {
              label: "Contacts",
              breadcrumbs: [
                "home",
                "whatsapp-cloud-api-broadcasts",
                "whatsapp-cloud-api-broadcast",
                "whatsapp-cloud-api-broadcast-contacts",
              ],
            },
          },
        ],
      },
    ],
  },
];
